import Scrollable from "@components/ui/Scrollable";
import {ComponentElem, ScrollableSetting} from "@components/interfaces";
import { Product } from "./ProductTypes";
import { Common } from "@components/common/CommonTypes";
import PhotoViewer from "@components/popups/PhotoViewer";
import ComponentBase from "@components/ComponentBase";

// export default class ReviewPhotoList extends Scrollable{
export default class ReviewPhotoList extends ComponentBase{

  static generate(dataList: Common.ImageWithThumb[], elem?: ComponentElem)
  {
    if(!elem) elem = ReviewPhotoList.createElem();
    let $wrapper = $(elem).find(".wrapper");
    $wrapper.empty();

    dataList.forEach((data: Common.ImageWithThumb, index: number)=>
    {
      let $photo = $(`<div class="photo"></div>`);
      $photo.css("background-image", `url(${data.thumb_src})`);
      $wrapper.append($photo);

      $photo.on("click", (event:Event)=>
      {
        event.preventDefault();
        // PhotoViewer.instance.showSinglePhoto(data.image_src);
        PhotoViewer.instance.showPhoto(index, dataList);
        
      });
    });

    return new ReviewPhotoList(elem);
  }

  constructor(elem: ComponentElem){

    let pcSetting: ScrollableSetting = 
    {
      itemWidth: 90,
      itemHeight: 90,
      gapX: 18.5,
      gapY: 0,
      numCols: 7,
      buttonMode: "press"
    }

    super(elem);
  }
}